/*
Sprawdzamy czy użytkownik ma ustawione cookie sekcji w której się znajduje. Cookie o nazwie 'section-type' przyjmuje wartość "he" lub "she".
Jeśli cookie nie istnieje to ustawiamy domyślną wartość na "he".
 */

export {selectSectionByPage, setSectionCookie, getSectionCookie, setCookie, getCookie};

function selectSectionByPage() {
    const bodyClasses = document.body.classList;
    if (bodyClasses.contains('finded-section-she')) {
        setSectionCookie('she');
    } else if(bodyClasses.contains('finded-section-he')) {
        setSectionCookie('he');
    }
    // if(!getCookie('section-type')) {
    //     if (window.location.pathname === '/') {
    //         setSectionCookie('he');
    //     } else if (window.location.pathname === '/ona/') {
    //         setSectionCookie('she');
    //     }
    // }
}

function setSectionCookie(type = 'he') {
    setCookie('section-type', type, 7);
}

function getSectionCookie() {
    const sectionCookie = getCookie('section-type');
    if (sectionCookie) {
        return sectionCookie;
    }
    setSectionCookie('he');
    return 'he';
}

function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
}